import { Directive, ElementRef, inject } from '@angular/core';
import { FormControlComponent } from './form-control.component';

/**
 * Registers the element this directive is applied as input with the parent form-control (if a parent form-control exists).
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[registerFormControlInput]',
})
export class RegisterFormControlInputDirective {
  public constructor() {
    const formControl = inject(FormControlComponent, { optional: true })!;
    const elementRef = inject(ElementRef);

    if (formControl) {
      formControl.registerChild(elementRef);
    }
  }
}
